import { useState, useCallback, useContext } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import * as ProsemirrorUtils from 'hubspot-prosemirror/prosemirror/ProsemirrorUtils';
import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/transitional/components/View';
import * as Immutable from 'immutable';
import { CommentsContext } from '../../../contexts/CommentsContext';
import { EngagementAssociationsContext } from '../../../contexts/EngagementAssociationsContext';
import { RichTextEditor } from '../../prosemirrorRichTextEditor/RichTextEditor';
import { useCommentSubmit } from '../../prosemirrorRichTextEditor/useCommentSubmit';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const CommentRTE = props => {
  const {
    owners,
    getOwnerIdsFromUserIds,
    getUserIdsFromOwnerIds
  } = useContext(CommentsContext);
  const {
    formattedAssociations
  } = useContext(EngagementAssociationsContext);
  const {
    atMentionedUserIds,
    autoFocus = false,
    onCancelClick,
    onSubmitClick,
    submitBtnText,
    value,
    draftValue,
    onChange
  } = props;
  const [commentData, setCommentData] = useState({
    html: draftValue || value || '',
    atMentions: atMentionedUserIds && atMentionedUserIds.length ? Immutable.fromJS(getOwnerIdsFromUserIds(atMentionedUserIds)) : null,
    containsText: value && value !== '' || false
  });
  const handleChange = useCallback(updatedState => {
    setCommentData(oldState => {
      const html = ProsemirrorUtils.convertToHtml(updatedState);
      if (onChange) {
        onChange(html);
      }
      const atMentions = ProsemirrorUtils.getAtMentions(updatedState);
      if (oldState.html !== html || oldState.atMentions !== atMentions) {
        return {
          html,
          atMentions,
          containsText: ProsemirrorUtils.hasContent(updatedState)
        };
      }
      return oldState;
    });
  }, [onChange]);
  const {
    mentionsPlugins,
    handleSubmitClick
  } = useCommentSubmit({
    commentData,
    getUserIdsFromOwnerIds,
    onSubmit: onSubmitClick
  });
  const handleCancelClick = () => {
    onCancelClick();
    setCommentData({
      html: '',
      atMentions: null,
      containsText: false
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(RichTextEditor, {
      onChange: handleChange,
      value: commentData.html,
      autoFocus: autoFocus,
      owners: owners,
      associations: formattedAssociations,
      mentionsPlugins: mentionsPlugins
    }), /*#__PURE__*/_jsxs(View, {
      paddingBlockStart: "200",
      paddingBlockEnd: "100",
      as: "div",
      children: [/*#__PURE__*/_jsx(Button, {
        "data-test-id": "comments-rteSubmitButton",
        use: "tertiary",
        size: "small",
        onClick: handleSubmitClick,
        disabled: !commentData.containsText || commentData.html === value,
        children: submitBtnText
      }), /*#__PURE__*/_jsx(Button, {
        "data-test-id": "comments-rteCancelButton",
        use: "link",
        onClick: handleCancelClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "objectCommentsThread.comments.cancelBtn"
        })
      })]
    })]
  });
};